








import Vue from 'vue';

export default Vue.extend({
  name: 'DocumentViewerPlaceholder',
  props: {
    placeholderText: {
      type: String,
      default: 'There is no image associated with this document.'
    }
  }
});
